import React from 'react';
import Image from 'react-bootstrap/Image';
import logo from '../../../images/Logo.png';

function LogoImage() {
    
    return  <Image src={logo} fluid alt="verktoypartner-logo"/>;
    
}
export default LogoImage;